(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.FullPageLoadingHandler = (function(superClass) {
    extend(FullPageLoadingHandler, superClass);

    function FullPageLoadingHandler() {
      return FullPageLoadingHandler.__super__.constructor.apply(this, arguments);
    }

    FullPageLoadingHandler.prototype.init = function(message) {
      var opts;
      if (message == null) {
        message = 'Loading data...';
      }
      FullPageLoadingHandler.__super__.init.call(this);
      this.layoutUrl = 'backend/loader';
      this.message = message;
      this.classes = 'shield dialog-loading';
      this.removeMessageOnLoad = false;
      this.useMessageWriter = false;
      opts = {
        'postOptions': {
          'message': this.message
        }
      };
      this.createDialog(opts);
      return this.openDialog();
    };

    return FullPageLoadingHandler;

  })(FullPageHandler);

}).call(this);
